import React, { useEffect, useState } from 'react';
import { useLanguage } from '../../../context/language';
import Loading from '../../../assets/loading.gif';
import { getStrLang } from '../../Translate';
import { callPayCashApi, getDeposit } from '../../../api/fastcoinService';
import { getURLBackToPanel } from '../../../context/brokersUrl';

const PayCash = (props) => {

    const { translate, lang } = useLanguage();

    const [loadingPayCashInfo, setLoadingPayCashInfo] = useState(false);
    const [infoPayCash, setInfoPayCash] = useState(sessionStorage.getItem("paycash_info") !== null ? JSON.parse(sessionStorage.getItem("paycash_info")) : undefined);
    const [waitingPayment, setWaitingPayment] = useState(sessionStorage.getItem("waiting_payment") !== null ? JSON.parse(sessionStorage.getItem("waiting_payment")) : false);
    const [isError, setIsError] = useState(false)
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        translate();
    }, [translate]);

    const callPicPay = () => {
        setLoadingPayCashInfo(true);
        callPayCashApi(sessionStorage.getItem("order_no"))
            .then(res => {
                if (res !== undefined) {
                    console.log('PayCash API Response:', res); // Debug log
                    setInfoPayCash(res);
                    sessionStorage.setItem("paycash_info", JSON.stringify(res));
                    setWaitingPayment(true);
                    setLoadingPayCashInfo(false)
                } else {
                    setInfoPayCash({ error: "Please, talk with the Administrator." });
                    setLoadingPayCashInfo(false);
                }
            })
            .catch(err => {
                console.log(err.toString());
                setIsError(true)
            }).finally(() => {
                setLoadingPayCashInfo(false);
                translate();
            });
    }

    useEffect(() => {
        let timeout;
        function checkPayment() {
            timeout = setTimeout(function () {
                getDeposit(sessionStorage.getItem("order_no"))
                    .then(res => {
                        if (res.status.toLowerCase() === "paid") {
                            setWaitingPayment(false);
                            sessionStorage.setItem("waiting_payment", false);
                            window.location.replace(getURLBackToPanel());
                        } else {
                            checkPayment();
                        }
                    })
                    .catch(err => {
                        alert(err);
                        checkPayment();
                    })
            }, 30000);
        }
        if (waitingPayment) {
            sessionStorage.setItem("waiting_payment", true);
            checkPayment();
        }
        return () => clearTimeout(timeout);
    }, [waitingPayment]);

    useEffect(() => {
        if (infoPayCash === undefined) {
            callPicPay()
        }
    }, [])
    
    const handleLoad = () => {
        setLoading(false);
    };
    return (
        <>
            {loadingPayCashInfo && <div className="group-pix-content">
                <div className="pix-container">
                    <div className="grup-crypto-opt">
                        <div className="msg-pix">
                            <img src={Loading} alt={"loading"} width="30px" height="30px" />
                        </div>
                    </div>
                </div>
            </div>}

            {!loadingPayCashInfo &&
                <div className="">
                    {infoPayCash !== undefined && infoPayCash?.paymentUrl && (
                        <div style={{ width: '100%' }}>
                            {loading && <div className="loader">Loading payment...</div>}
                            <iframe
                                src={infoPayCash.paymentUrl}
                                title="Pay Cash Payment"
                                width="100%"
                                height="600px"
                                onLoad={handleLoad}
                                style={{ display: loading ? 'none' : 'block' }}
                            />
                        </div>
                    )}
                    {isError && <div style={{ display: 'flex', flexDirection: 'row', width: '100%', alignItems: 'center', justifyContent: 'center' }}>
                        <h4>{getStrLang(lang.nameLang, "error_picpay")} {getStrLang(lang.nameLang, "error_boleto2")}</h4>
                    </div>}
                </div>}



        </>

    )
}

export default PayCash;